// @flow

import type {StatelessFunctionalComponent} from 'react';

import styled from '@emotion/styled';

export const Container: StatelessFunctionalComponent<> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 0;
`;
